import { ContentInfo } from '@barbanet/api-service'

/* eslint-disable no-unused-vars */
export type IVehicleType =
	| 'HEAVY_DUTY_TRUCK'
	| 'LIGHT_COMMERCIAL_VEHICLE'
	| 'MOTORCYCLE'
export enum IFormStatusEnum {
	IS_PRISTINE = -1,
	PENDING,
	WAITING_TO_ACCEPT_ADMIN,
	REJECTED,
	ACTIVE,
	INACTIVE,
	CLOSED_BY_USER,
	CLOSED_BY_ADMIN,
	INQUIRY,
	DOCUMENT_INFO_NOTFOUND,
	EXPIRED
}
export interface IVehicleInfo {
	id?: string
	type?: IVehicleType
	status?: IFormStatusEnum
}
export interface INonHeavyDriverInfo {
	status?: IFormStatusEnum
	licenseFrontImageInfo?: Nullable<ContentInfo>
	licenseBackImageInfo?: Nullable<ContentInfo>
	profileImageInfo?: Nullable<ContentInfo>
}
export interface IHeavyDriverInfo {
	id?: string
	status?: IFormStatusEnum
	smartCardNumber?: Nullable<number>
	licenseNumber?: Nullable<number>
	smartCardExpirationDate?: Nullable<number>
	licenseExpirationDate?: Nullable<number>
	profileImageInfo?: Nullable<ContentInfo>
}
export interface IHeavyFleetInfo {
	id?: string
	status?: IFormStatusEnum
	smartCardFrontImageInfo?: Nullable<ContentInfo>
	cardNumber?: string
	plaqueNumber?: string
	craneName?: string
	craneType?: string
	vehicleIdentification?: string
	systemName?: string
	issueDate?: number
	manufactureYear?: string
	technicalInspectionDate?: number
}
export interface IHeavyTruckInfo extends IVehicleInfo {
	driverInfo?: IHeavyDriverInfo
	fleetInfo?: IHeavyFleetInfo
}
export interface IMotorcycleInfo extends IVehicleInfo {
	driverInfo?: INonHeavyDriverInfo
	fleetInfo?: IMotorcycleFleetInfo
}
export interface IMotorcycleFleetInfo {
	status?: IFormStatusEnum
	vehicleImageInfos?: Nullable<ContentInfo[]>
	vehicleCardFrontImageInfo?: Nullable<ContentInfo>
	vehicleCardBackImageInfo?: Nullable<ContentInfo>
	boxType?: Nullable<number>
	boxLength?: Nullable<number>
	boxWidth?: Nullable<number>
	boxHeight?: Nullable<number>
}
export interface ILightCommercialVehicleInfo extends IVehicleInfo {
	driverInfo?: INonHeavyDriverInfo
	fleetInfo?: ILightCommercialVehicleFleetInfo
}
export interface ILightCommercialVehicleFleetInfo {
	status?: IFormStatusEnum
	vehicleImageInfos?: Nullable<ContentInfo[]>
	vehicleCardFrontImageInfo?: Nullable<ContentInfo>
	vehicleCardBackImageInfo?: Nullable<ContentInfo>
	cargoBedLength?: Nullable<number>
	cargoBedWidth?: Nullable<number>
	cargoBedHeight?: Nullable<number>
}
